import { mobileNumber } from '@jfs/ui-new'
import { required } from '@jfs/utils'
import { AepsTextInput } from '../../../comps/AepsTextInput'
import { OtpTextInputWithMaxRetry } from '../../../comps/OtpTextInputWithMaxRetry'
import { REFUND_STRINGS } from '../RefundStrings'
import { REFUND_CONSTANTS } from '../RefundStrings/Constants'
import { styles } from './styles'

export const FORM_FIELDS = {
  MOBILE: 'mobileNumber',
  OTP: 'Otp',
  DEBIT_AMOUNT_INFO: 'debitInfo',
}

export const OtpForm = ({
  customerMobileNumber,
  onResendOtpButtonPress,
  isResendOtpLoading,
  sendOtpRetryCount,
}: any) => [
  {
    verticalSpacing: 0,
    formItems: [
      {
        fieldName: FORM_FIELDS.MOBILE,
        ComponentName: AepsTextInput,
        label: REFUND_STRINGS.applicantMonileNo,
        value: customerMobileNumber,
        validationSchema: mobileNumber,
        disabled: true,
        maxLength: REFUND_CONSTANTS.VALID_MOBILE_LENGTH,
      },
      {
        fieldName: FORM_FIELDS.OTP,
        ComponentName: OtpTextInputWithMaxRetry,
        placeholder: REFUND_STRINGS.otp,
        validationSchema: required,
        ...styles.textInputStyle,
        onResendOtpButtonPress: onResendOtpButtonPress,
        isResendOtpLoading: isResendOtpLoading,
        maxLength: REFUND_CONSTANTS.OTP_VALID_LENGTH,
        sendOtpRetryCount,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
